/**
 * Builds a URL query string from an object, skipping any keys whose value is
 * undefined, null, or an empty string.
 *
 * @example
 * buildQueryString({ limit: 10, offset: 0, search: undefined })
 * // → "limit=10&offset=0"
 */
export function buildQueryString(
  params: Record<string, string | number | boolean | null | undefined>,
): string {
  const urlParams = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== "") {
      urlParams.set(key, String(value));
    }
  }
  return urlParams.toString();
}
